var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.params.data.pollyUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.params.data.pollyUrl ? 'Apri url' : '-'))]),_vm._v(" | "),_c('file-select',{on:{"input":_vm.uploadAudio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }